import React, { useState } from 'react';
import axios from 'axios';
import { ClipboardList, Loader2, ChevronDown } from 'lucide-react';
import { SearchBar, matchesSearch, formatDate, getActionLabel } from './shared';

const PAGE = 200;

export default function LogsTab({ logs, setLogs, logsTotal, setLogsTotal, searchTerm, setSearchTerm, API_URL, authHeaders }) {
  const [loading, setLoading] = useState(false);
  const hasMore = logsTotal > logs.length;

  const loadMore = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API_URL}/api/community/admin/logs`, { params: { limit: PAGE, skip: logs.length }, headers: authHeaders });
      const seen = new Set(logs.map(l => l.id));
      setLogs([...logs, ...(r.data.logs || []).filter(l => !seen.has(l.id))]);
      setLogsTotal(r.data.total ?? logsTotal);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const rows = logs.filter(l => matchesSearch(l, searchTerm, ['email', 'username', 'notes', 'action', 'performed_by_name']) || getActionLabel(l.action).toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="tab-content" data-testid="logs-content">
      <div className="section-card"><h3><ClipboardList size={18} /> Logbuch <span className="logs-count" data-testid="logs-count">({logs.length}{logsTotal > logs.length ? ` von ${logsTotal}` : ''})</span></h3>
        <SearchBar value={searchTerm} onChange={setSearchTerm} placeholder="Logbuch durchsuchen (Aktion, E-Mail, Benutzer, Notiz, Ausgeführt von)…" />
        <div className="user-table-wrap"><table className="user-table logs-table"><thead><tr><th>Aktion</th><th>Betroffener (E-Mail)</th><th>Benutzername</th><th>Notizen</th><th>Ausgeführt von</th><th>Zeitpunkt</th></tr></thead><tbody>
          {rows.map(log => (
            <tr key={log.id} data-testid={`log-row-${log.id}`}>
              <td><span className={`action-badge action-${log.action}`}>{getActionLabel(log.action)}</span></td>
              <td>{log.email}</td>
              <td>{log.username}</td>
              <td className="notes-cell">{log.notes}</td>
              <td className="log-actor" data-testid={`log-actor-${log.id}`}>{log.performed_by_name || (log.performed_by ? '–' : <span className="log-actor-system">System / Nutzer selbst</span>)}</td>
              <td>{formatDate(log.timestamp)}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={6} className="hint-text" style={{ textAlign: 'center' }}>Keine Einträge gefunden.</td></tr>}
        </tbody></table></div>
        {hasMore && (
          <div style={{ textAlign: 'center', marginTop: '0.75rem' }}>
            <button type="button" className="btn-sm" onClick={loadMore} disabled={loading} data-testid="logs-load-more">
              {loading ? <Loader2 size={14} className="spin" /> : <ChevronDown size={14} />} Weitere {Math.min(PAGE, logsTotal - logs.length)} laden ({logsTotal - logs.length} verbleibend)
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
